import {
  getPostApiV1ThreeLetterCodeClientAdminsClientPortalItemsMutationFetcher,
  getPostApiV1ThreeLetterCodeClientAdminsClientPortalItemsMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { PostApiV1ThreeLetterCodeClientAdminsClientPortalItems201 } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import type { AxiosError } from 'axios';

export const usePostPortal = (
  threeLetterCode: string,
  options?: {
    onSuccess?: (data: PostApiV1ThreeLetterCodeClientAdminsClientPortalItems201) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPostApiV1ThreeLetterCodeClientAdminsClientPortalItemsMutationKey(threeLetterCode),
    getPostApiV1ThreeLetterCodeClientAdminsClientPortalItemsMutationFetcher(threeLetterCode),
    options
  );
};
